export default {
    headers: {
        key: {
            id: 'mobileReports.headers.key'
        },
        week: {
            id: 'mobileReports.headers.week'
        },
        imbPatterns: {
            id: 'mobileReports.headers.imbPatterns'
        }
    },
    legends: {
        approximateTime: {
            id: 'mobileReports.legends.approximateTime'
        },
        injection: {
            id: 'mobileReports.legends.injection'
        },
        manualReading: {
            id: 'mobileReports.legends.manualReading'
        },
        twoHoursApartReadings: {
            id: 'mobileReports.legends.twoHoursApartReadings'
        }
    },
    formulas: {},
    labels: {
        from: {
            id: 'mobileReports.labels.from'
        },
        to: {
            id: 'mobileReports.labels.to'
        },
        bgm: {
            id: 'mobileReports.labels.bgm'
        },
        bgmUnit: {
            mgdl: {
                id: 'mobileReports.labels.bgmUnit.mgdl'
            }
        },
        carbs: {
            id: 'mobileReports.labels.carbs'
        },
        carbsUnit: {
            G: {
                id: 'mobileReports.labels.carbsUnit.G'
            }
        },
        injection: {
            id: 'mobileReports.labels.injection'
        },
        injectionUnit: {
            id: 'mobileReports.labels.injectionUnit'
        },
        activity: {
            id: 'mobileReports.labels.activity'
        },
        activityUnit: {
            id: 'mobileReports.labels.activityUnit'
        },
        diaryGeneratedOn: {
            id: 'mobileReports.labels.diaryGeneratedOn'
        },
        pageOf: {
            id: 'mobileReports.labels.pageOf'
        },
        average: {
            id: 'mobileReports.labels.average'
        },
        nReadingsAt: {
            id: 'mobileReports.labels.nReadingsAt'
        }
    },
    summaries: {
        injections: {
            id: 'mobileReports.summaries.injections'
        },
        veryHigh: {
            id: 'mobileReports.summaries.veryHigh'
        },
        veryLow: {
            id: 'mobileReports.summaries.veryLow'
        },
        standardDeviation: {
            id: 'mobileReports.summaries.standardDeviation'
        },
        persentOfReadingsInRange: {
            id: 'mobileReports.summaries.persentOfReadingsInRange'
        },
        averagePreMeal: {
            id: 'mobileReports.summaries.averagePreMeal'
        },
        averageStrictPostMeal: {
            id: 'mobileReports.summaries.averageStrictPostMeal'
        },
        averageOverall: {
            id: 'mobileReports.summaries.averageOverall'
        },
        dailySummary: {
            id: 'mobileReports.summaries.dailySummary'
        },
        average: {
            id: 'mobileReports.summaries.average'
        }
    },
    glucoseReport: {
        afterMealTarget: {
            id: 'mobileReports.glucoseReport.afterMealTarget'
        },
        beforeMealTarget: {
            id: 'mobileReports.glucoseReport.beforeMealTarget'
        },
        title: {
            id: 'mobileReports.glucoseReport.title'
        },
        dateOfBirth: {
            id: 'mobileReports.glucoseReport.dateOfBirth'
        },
        preMealRange: {
            id: 'mobileReports.glucoseReport.preMealRange'
        },
        postMealRange: {
            id: 'mobileReports.glucoseReport.postMealRange'
        },
        correctRange: {
            id: 'mobileReports.glucoseReport.correctRange'
        },
        readings: {
            id: 'mobileReports.glucoseReport.readings'
        },
        tableDays: {
            id: 'mobileReports.glucoseReport.tableDays'
        },
        tableAutomaticReadings: {
            id: 'mobileReports.glucoseReport.tableAutomaticReadings'
        },
        tableManualReadings: {
            id: 'mobileReports.glucoseReport.tableManualReadings'
        },
        tableReadingsPerDay: {
            id: 'mobileReports.glucoseReport.tableReadingsPerDay'
        },
        tableAveragePreMeal: {
            id: 'mobileReports.glucoseReport.tableAveragePreMeal'
        },
        tableAveragePostMeal: {
            id: 'mobileReports.glucoseReport.tableAveragePostMeal'
        },
        tableStandardDeviation: {
            id: 'mobileReports.glucoseReport.tableStandardDeviation'
        },
        tableRange: {
            id: 'mobileReports.glucoseReport.tableRange'
        },
        tableVariability: {
            id: 'mobileReports.glucoseReport.tableVariability'
        },
        generatedReport: {
            id: 'mobileReports.glucoseReport.generatedReport'
        },
        headerGlucoseLevelHeader: {
            id: 'mobileReports.glucoseReport.headerGlucoseLevelHeader'
        },
        bloodGlucoseAbove: {
            id: 'mobileReports.glucoseReport.bloodGlucoseAbove'
        },
        bloodGlucoseBelow: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBelow'
        },
        bloodGlucoseInTarget: {
            id: 'mobileReports.glucoseReport.bloodGlucoseInTarget'
        },
        headerBloodGlucoseHeader: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeader'
        },
        bloodGlucoseBottom: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottom'
        },
        bloodGlucoseBottomUnmarkedReadings: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomUnmarkedReadings'
        },
        headerBloodGlucoseHeaderPreMeal: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeaderPreMeal'
        },
        bloodGlucoseBottomPreMeal: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomPreMeal'
        },
        headerBloodGlucoseHeaderPostMeal: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeaderPostMeal'
        },
        bloodGlucoseBottomPostMeal: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomPostMeal'
        },
        textField: {
            id: 'mobileReports.glucoseReport.textField'
        },
        criticalLow: {
            id: 'mobileReports.glucoseReport.criticalLow'
        },
        criticalHigh: {
            id: 'mobileReports.glucoseReport.criticalHigh'
        },
        low: {
            id: 'mobileReports.glucoseReport.low'
        },
        high: {
            id: 'mobileReports.glucoseReport.high'
        },
        diabetesType: {
            id: 'mobileReports.glucoseReport.diabetesType'
        },
        manuallyEnteredReading: {
            id: 'mobileReports.glucoseReport.manuallyEnteredReading'
        },
        treatmentType: {
            id: 'mobileReports.glucoseReport.treatmentType'
        },
        reportGeneratedOn: {
            id: 'mobileReports.glucoseReport.reportGeneratedOn'
        },
        tableCriticalHigh: {
            id: 'mobileReports.glucoseReport.tableCriticalHigh'
        },
        tableCriticalLow: {
            id: 'mobileReports.glucoseReport.tableCriticalLow'
        }
    },
    dailyReport: {
        tableCriticalHigh: {
            id: 'mobileReports.dailyReport.tableCriticalHigh'
        },
        tablePostMeal: {
            id: 'mobileReports.dailyReport.tablePostMeal'
        },
        tablePreMeal: {
            id: 'mobileReports.dailyReport.tablePreMeal'
        },
        tableCriticalLow: {
            id: 'mobileReports.dailyReport.tableCriticalLow'
        },
        standardDay: {
            id: 'mobileReports.dailyReport.standardDay'
        }
    },
    infos: {
        noimbPatterns: {
            id: 'mobileReports.infos.noimbPatterns'
        },
        detected: {
            id: 'mobileReports.infos.detected'
        }
    },
    kpi: {},
    IMBPatterns: {
        patternNames: {
            CRITICAL_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.criticalLow'
            },
            CRITICAL_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.criticalHigh'
            },
            FASTING_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.fastingHigh'
            },
            FASTING_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.fastingLow'
            },
            POST_DINNER_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.postDinnerLow'
            },
            PRE_LUNCH_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.preLunchLow'
            },
            PRE_DINNER_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.preDinnerLow'
            },
            PRE_DINNER_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.preDinnerHigh'
            },
            PRE_LUNCH_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.preLunchHigh'
            },
            POST_DINNER_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.postDinnerHigh'
            },
            RUNNING_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.runningLow'
            },
            RUNNING_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.runningHigh'
            },
            DAY_OF_THE_WEEK_HIGH: {
                id: 'mobileReports.IMBPatterns.patternNames.dayOfTheWeekHigh'
            },
            DAY_OF_THE_WEEK_LOW: {
                id: 'mobileReports.IMBPatterns.patternNames.dayOfTheWeekLow'
            }
        },
        statuses: {
            DISMISSED: {
                id: 'mobileReports.IMBPatterns.statuses.dismissed'
            },
            NEW: {
                id: 'mobileReports.IMBPatterns.statuses.new'
            },
            IMPROVED: {
                id: 'mobileReports.IMBPatterns.statuses.improved'
            },
            TIMED_OUT: {
                id: 'mobileReports.IMBPatterns.statuses.timedOut'
            },
            CANCELED: {
                id: 'mobileReports.IMBPatterns.statuses.canceled'
            },
            OVERCORRECTED: {
                id: 'mobileReports.IMBPatterns.statuses.overcorrected'
            },
            NOT_IMPROVED: {
                id: 'mobileReports.IMBPatterns.statuses.notImproved'
            },
            NEEDS_IMPROVEMENT: {
                id: 'mobileReports.IMBPatterns.statuses.needsImprovement'
            }
        },
        patternDescriptions: {
            CRITICAL_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalLow.negative'
                }
            },
            CRITICAL_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.criticalHigh.negative'
                }
            },
            FASTING_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingHigh.negative'
                }
            },
            FASTING_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.fastingLow.negative'
                }
            },
            POST_DINNER_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerLow.negative'
                }
            },
            PRE_LUNCH_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchLow.negative'
                }
            },
            PRE_DINNER_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerLow.negative'
                }
            },
            PRE_DINNER_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preDinnerHigh.negative'
                }
            },
            PRE_LUNCH_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.preLunchHigh.negative'
                }
            },
            POST_DINNER_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.postDinnerHigh.negative'
                }
            },
            RUNNING_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningLow.negative'
                }
            },
            RUNNING_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.runningHigh.negative'
                }
            },
            DAY_OF_THE_WEEK_LOW: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekLow.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekLow.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekLow.negative'
                }
            },
            DAY_OF_THE_WEEK_HIGH: {
                normal: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekHigh.normal'
                },
                positive: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekHigh.positive'
                },
                negative: {
                    id: 'mobileReports.IMBPatterns.patternDescriptions.dayOfTheWeekHigh.negative'
                }
            }
        }
    }
};
